import React from "react";

import { Button, Img, PagerIndicator, Text } from "components/index";
import QuickLookDialogRatingbar from "components/QuickLookDialogRatingbar";
import { useNavigate } from "react-router-dom";
import { formatCurrency } from "../../helpers/number";

const QuicklookdialogPage = ({ selectedProduct, onClose }) => {
  const navigate = useNavigate();
  return (
    <>
      <div style={{
        position: "fixed",
        display: selectedProduct ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        zIndex: 100000,
        background: "rgba(0,0,0,.5)",
        // opacity: .5,
        padding: '10%'
      }} onClick={onClose}>
        <div onClick={(e)=>{
          e.preventDefault();
        }} className="flex bg-white-A700 rounded-lg md:flex-col h-full flex-row gap-5 items-center justify-between max-w-5xl mt-[13px] mx-auto md:px-5 w-full">
          <div className="w-1/2 h-full flex justify-center items-center md:w-full">
            <Img
              className="m-auto object-contain max-h-full rounded-[10px] w-full"
              src={selectedProduct?.images[0]}
              alt="unsplashvxhpxyq"
            />
            {/*<PagerIndicator*/}
            {/*  className="absolute bottom-[1%] flex gap-1 h-[17px] md:h-auto inset-x-[0] justify-between mx-auto w-16"*/}
            {/*  count={4}*/}
            {/*  activeCss="inline-block cursor-pointer rounded-[50%] h-2 bg-indigo-A700_01 w-2 relative"*/}
            {/*  activeIndex={1}*/}
            {/*  inactiveCss="inline-block cursor-pointer rounded-[50%] h-2 bg-gray-300 w-2 relative"*/}
            {/*  selectedWrapperCss="inline-block"*/}
            {/*  unselectedWrapperCss="inline-block"*/}
            {/*/>*/}
            {/*<Button*/}
            {/*  className="absolute flex h-[38px] inset-y-[0] items-center justify-center my-auto right-[4%] w-[38px]"*/}
            {/*  shape="round"*/}
            {/*  color="indigo_A700"*/}
            {/*  size="sm"*/}
            {/*  variant="fill"*/}
            {/*>*/}
            {/*  <Img*/}
            {/*    className="h-6"*/}
            {/*    src="images/img_keyboardarrowup.svg"*/}
            {/*    alt="arrowright"*/}
            {/*  />*/}
            {/*</Button>*/}
          </div>

          <div
            className="bg-white-A700 max-h-full flex md:flex-1 flex-col items-center justify-start p-[17px] w-1/2 md:w-full">
            <div className="mb-[16px] mt-[3px] relative w-[98%] sm:w-full">
              <div
                className="flex flex-col gap-[18px] inset-x-[0] items-start justify-start mx-auto top-[0] w-[99%]">
                <Text
                  className="leading-[24.00px] text-black-900_dd text-xl tracking-[0.15px]"
                  size="txtInterRegular20"
                >
                  <>
                    {selectedProduct?.product}
                  </>
                </Text>
                <QuickLookDialogRatingbar className="sm:flex-col flex-row gap-3 grid grid-cols-5 w-[57%]" />
                <div className="flex flex-col items-start justify-start w-[48%] md:w-full">
                  <div className="flex flex-row items-start justify-start w-[52%] md:w-full">
                    <Text
                      className="text-blue_gray-700 text-xs tracking-[0.40px]"
                      size="txtInterRegular12"
                    >
                      TZS
                    </Text>
                    <Text
                      className="ml-[3px] text-black-900_dd text-xl tracking-[0.15px]"
                      size="txtInterMedium20"
                    >
                      {formatCurrency(selectedProduct?.retailPrice)}
                    </Text>
                  </div>
                  <Text
                    className="text-black-900_99 mt-3 text-xs tracking-[0.25px]"
                    size="txtInterRegular12Black90099"
                  >
                    Only few remains in stock order now
                  </Text>
                </div>
                <div className="flex flex-col font-urbanist items-center justify-start">
                  <Text
                    className="leading-[19.00px] text-black-900_dd text-sm tracking-[0.20px] w-full"
                    size="txtUrbanistRegular14"
                  >
                      <span className="text-black-900_dd tracking-[0.15px] font-roboto text-left text-base font-normal">
                        {selectedProduct?.description}
                      </span>
                    {/*<span className="text-black-900_dd font-urbanist text-left font-normal">*/}
                    {/*  {" "}*/}
                    {/*</span>*/}
                    {/*<span*/}
                    {/*  className="text-indigo-A700_01 tracking-[0.15px] font-roboto text-left text-base font-bold">*/}
                    {/*  Read more...*/}
                    {/*</span>*/}
                  </Text>
                </div>
              </div>
              <div
                className="flex sm:flex-col flex-wrap flex-row gap-7 inset-x-[0] items-center justify-start mx-auto w-full">
                <Button
                  onClick={() => navigate("/productdetailpage")}
                  className="cursor-pointer flex items-center px-5 justify-center rounded-[18px]"
                  leftIcon={
                    <Img
                      className="mr-[9px]"
                      src="images/img_visibility_black_900.svg"
                      alt="Visibility"
                    />
                  }
                  shape="round"
                  color="orange_A200"
                  size="xs"
                  variant="fill"
                >
                  <div className="text-left text-sm tracking-[0.25px]">
                    Buying options
                  </div>
                </Button>
                <Button
                  onClick={() => navigate("/cartreviewpage")}
                  className="cursor-pointer flex items-center justify-center px-5 rounded-[18px]"
                  leftIcon={
                    <Img
                      className="mr-[13px]"
                      src="images/img_shopping_cart_white_a700.svg"
                      alt="Shopping cart"
                    />
                  }
                  shape="round"
                  color="indigo_A700"
                  size="xs"
                  variant="fill"
                >
                  <div className="text-left text-sm tracking-[0.25px]">
                    Add to cart
                  </div>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuicklookdialogPage;
